import { Platform, Share } from 'react-native'

import LazyHOC from '@zet/common/components/lazyHoc'
import { Button, Icon, colors } from '@zet/design-system'
import { Stack, XStack, YStack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import { B1, B4, H5, H6, SH3 } from '@zet/design-system/typography'
import { useUserContext } from '@zet/feature-user'
import { i18n } from '@zet/localization'
import Lottie from 'lottie-react'
import LottieView from 'lottie-react-native'

import { IRequestData } from '../../api/functions/customerAdditionStateMachine'
import { useAddCustomerNextState } from '../../api/hooks'
import { useGenerateShareLinkToAddCustomer } from '../../api/hooks/useGenerateShareLinkToAddCustomer'
import AddCustomerBackHandlerHOC from '../../components/addCustomerBackHandlerHOC'
import useCustomerStore from '../../store'
import useMyCustomersStore from '../../store/myCustomers'
import { linkCall } from '../../utils/addCustomerStates'

const VerifyCustomerConsent = ({
  route,
}: {
  route: {
    params: {
      customerId: number | undefined
      isReconsentFlow: boolean
      fullName: string | undefined
    }
  }
}) => {
  const {
    params: { customerId, isReconsentFlow = false, fullName },
  } = route
  const { selectedCustomer } = useCustomerStore((state) => state)

  const { partnerId } = useMyCustomersStore()

  const { data: user } = useUserContext()

  const { mutate: mutateWithExperiments, isLoading: isExperimentsLoading } =
    useAddCustomerNextState()
  const { mutate } = useGenerateShareLinkToAddCustomer()

  const handleSubmit = () => {
    const requestBodyData = {
      customerId: customerId as number,
      phoneNumber: selectedCustomer?.phoneNumber as string,
      fullName: selectedCustomer?.name as string,
      screenName: 'SHOWN_PHONE_CALL_SCREEN',
      nonVerifiedBridgeCustomerAddition: true,
    }
    mutateWithExperiments(requestBodyData as IRequestData)
  }

  const onShare = async (response) => {
    await Share.share({
      message: i18n.t('myCustomers.shareDescription', {
        link: response?.data?.link,
        name: user?.fullName,
      }),
    })
  }
  const handleShareLink = () => {
    mutate(
      { linkType: 'globalShareLink', partnerId: partnerId },
      { onSuccess: onShare }
    )
  }

  return (
    <LazyHOC>
      <AddCustomerBackHandlerHOC>
        <YStack className="flex-1 justify-between bg-white p-3">
          <YStack>
            <Stack>
              <H5>{i18n.t('customerDetails.customerPermission')}</H5>
            </Stack>
            <Stack className="mb-4 mt-3">
              {Platform.OS === 'web' ? <Lottie animationData={require('../../../assets/lottie/Verification.json')} /> : 
              <LottieView
                autoPlay
                className={`self-center `}
                style={{ height: 192, width: 192 }}
                source={require('../../../assets/lottie/Verification.json')}
              /> }
            </Stack>
            <XStack
              className="mt-5 items-center justify-between rounded border p-3"
              style={{ borderColor: colors.grays[40] }}
            >
              <YStack>
                <SH3>{selectedCustomer?.name}</SH3>
                <B4>+91-{selectedCustomer?.phoneNumber ?? user?.fullName}</B4>
              </YStack>
              <Pressable
                onPress={() => linkCall(selectedCustomer?.phoneNumber)}
              >
                <Stack
                  className="items-center justify-center rounded border p-1"
                  style={{ borderColor: colors.primary[30] }}
                >
                  <Icon type="PhoneFilled" color={colors.primary[100]} />
                </Stack>
              </Pressable>
            </XStack>
            <Stack className="mt-3">
              <B1 className="text-gray-700">
                {i18n.t('customerDetails.verificationPending')}
                <H6> {selectedCustomer?.phoneNumber} </H6>
                {i18n.t('customerDetails.proceedWith')}
              </B1>
            </Stack>
          </YStack>
          <YStack>
            <Button
              outlined={true}
              className="mb-4/2 w-full self-center py-3"
              textStyle="text-primary-100"
              onPress={handleShareLink}
            >
              {i18n.t('customerDetails.shareVerifycationLink')}
            </Button>
            <Button
              className="w-full self-center py-3"
              textStyle="text-white"
              onPress={handleSubmit}
            >
              {i18n.t('customerDetails.sendOtpViaSms')}
            </Button>
          </YStack>
        </YStack>
      </AddCustomerBackHandlerHOC>
    </LazyHOC>
  )
}
export default VerifyCustomerConsent
